export default __webpack_public_path__ + "static/media/cus2.f199fdaf.png";